import {spotheroGet} from 'api';
import {type ApiResponse} from 'api/api.types';
import {apiDateFormat} from 'utils/date-time';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys} from 'utils/format-strings';
import dayjs from 'utils/dayjs';

import {
    type CompPassSummaryCount,
    type RawCompPassSummaryCountsResponse,
} from 'api/comp-passes/comp-pass.types';

interface GetCompPassSummaryCountsParams {
    facilityId: number;
    date?: dayjs.Dayjs;
}

/**
 * Formats the request parameters for getting comp pass summary counts.
 */
const formatCompPassSummaryCountParams = (date: dayjs.Dayjs) => {
    const formattedParams = {
        date: dayjs(date).format(apiDateFormat),
    };

    return formattedParams;
};

/**
 * Formats the response from getting comp pass summary counts.
 */
const formatCompPassSummaryCountsResponse = (
    response: ApiResponse<RawCompPassSummaryCountsResponse>
) => {
    const formattedResponse: CompPassSummaryCount = camelizeKeys(
        response.data.data
    );

    return formattedResponse;
};

/**
 * Gets comp pass summary counts for a given facility and date.
 *
 * @see '/api/v1/facilities/{facilityId}/comp-pass/passes/aggregates/'
 */
export const getCompPassSummaryCounts = async ({
    facilityId,
    date,
}: GetCompPassSummaryCountsParams) => {
    try {
        let formattedParams = {};

        if (date) {
            formattedParams = formatCompPassSummaryCountParams(date);
        }

        const response = await spotheroGet<RawCompPassSummaryCountsResponse>(
            `/facilities/${facilityId}/comp-pass/passes/aggregates/`,
            formattedParams
        );

        const formatedResponse = formatCompPassSummaryCountsResponse(response);

        return formatedResponse;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};
